"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupedMenuContent = void 0;
const react_1 = __importStar(require("react"));
const material_1 = require("@mui/material");
const grouped_menu_content_styles_1 = require("./grouped-menu-content.styles");
const loading_indicator_1 = require("../../loading-indicator");
const grouped_menu_item_content_component_1 = require("./grouped-menu-item-content.component");
const GroupedMenuContent = ({ options, selectedIds, onSelect, isEmpty, isDisabled, isLoading, isSearching, initialExpandedParentId, moreItemsLoading, registerExpandMethods, onExpandCountChange, }) => {
    const [expandedParents, setExpandedParents] = (0, react_1.useState)([]);
    const toggleExpand = (0, react_1.useCallback)((parentId) => {
        setExpandedParents((prev) => {
            const next = new Set(prev);
            if (next.has(parentId)) {
                next.delete(parentId);
            }
            else {
                next.add(parentId);
            }
            return Array.from(next);
        });
    }, []);
    const expandAll = (0, react_1.useCallback)(() => {
        const allIds = options.map((group, idx) => { var _a; return (_a = group.value) !== null && _a !== void 0 ? _a : `group-${idx}`; });
        setExpandedParents(allIds);
    }, [options]);
    const collapseAll = (0, react_1.useCallback)(() => {
        setExpandedParents([]);
    }, []);
    (0, react_1.useEffect)(() => {
        setExpandedParents(initialExpandedParentId ? [initialExpandedParentId] : []);
    }, [initialExpandedParentId, options]);
    (0, react_1.useEffect)(() => {
        if (registerExpandMethods) {
            registerExpandMethods(expandAll, collapseAll);
        }
    }, [registerExpandMethods, expandAll, collapseAll]);
    (0, react_1.useEffect)(() => {
        if (onExpandCountChange) {
            onExpandCountChange(expandedParents.length);
        }
    }, [expandedParents, onExpandCountChange]);
    if (isLoading && isEmpty) {
        return (react_1.default.createElement(grouped_menu_content_styles_1.StyledMenuContent, null, react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "loading-indicator" })));
    }
    return (react_1.default.createElement(grouped_menu_content_styles_1.StyledMenuContent, null, react_1.default.createElement(material_1.List, { sx: {
            width: '100%',
            maxHeight: 300,
            overflow: 'auto',
            position: 'relative',
        }, subheader: react_1.default.createElement("li", null) }, options.map((group, gIndex) => {
        var _a;
        const parentId = (_a = group.value) !== null && _a !== void 0 ? _a : `group-${gIndex}`;
        const isExpanded = expandedParents.includes(parentId);
        return (react_1.default.createElement(grouped_menu_item_content_component_1.GroupedMenuItem, { key: parentId, group: group, parentId: parentId, selectedIds: selectedIds, isDisabled: isDisabled, isExpanded: isExpanded, onSelect: onSelect, toggleExpand: toggleExpand }));
    })), isSearching && react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "loading-indicator" }), moreItemsLoading && react_1.default.createElement(loading_indicator_1.LoadingIndicator, { className: "loading-indicator" })));
};
exports.GroupedMenuContent = GroupedMenuContent;
